export const AUTOMATION_RULES_STEP_ID = "automation-rules";
export const AUTOMATION_RULES_STEP_TITLE = "Automation Rules";
